import styled from "styled-components";
import { Icon } from "antd";

const CustomizedIcon = styled(Icon)`
	font-size: ${props => props.size === "large" ? "72px" : "32px"} !important;
`;

export default CustomizedIcon;
